import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'widgets/Modal/Modal';

import ShoppingListsModal from 'apps/shoppingLists/containers/ShoppingListsModal';
import { pageEventTypes, wa } from 'apps/analytics';

const ShoppingLists = ({
  onClose,
  shoppingListsOpened,
}) => (shoppingListsOpened && (
  <Modal
    onCancel={() => {
      wa.triggerPageEvent(pageEventTypes.QM_CLOSE_SHOPPING_LIST_POPUP);
      if (onClose) {
        onClose();
      }
    }}
    className="sl-modal"
    title="Add to list"
  >
    <ShoppingListsModal />
  </Modal>
));

ShoppingLists.propTypes = {
  shoppingListsOpened: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default ShoppingLists;
